/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Inline_Toast_Signed_InInputs */

const en_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in.`)
};

const es_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión iniciada.`)
};

const de_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angemeldet.`)
};

const zh_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已登录。`)
};

const ar_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تسجيل الدخول.`)
};

const fr_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecté.`)
};

const vi_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng nhập.`)
};

const sw_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umeingia.`)
};

const th_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงชื่อเข้าใช้แล้ว`)
};

const bs_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavljeni ste.`)
};

const ja_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインしました。`)
};

const ko_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인되었습니다.`)
};

const pt_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você entrou.`)
};

const it_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso effettuato.`)
};

const sv_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du är inloggad.`)
};

const nl_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingelogd.`)
};

const da_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er logget ind.`)
};

const nb_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er logget inn.`)
};

const fi_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjauduit sisään.`)
};

const pl_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalogowano.`)
};

const ru_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы вошли.`)
};

const tr_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş yapıldı.`)
};

const hi_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइन इन हो गया।`)
};

const id_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhasil masuk.`)
};

const ms_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berjaya log masuk.`)
};

const cs_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášeno.`)
};

const el_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνδεθήκατε.`)
};

const he_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברתם.`)
};

const af_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangemeld.`)
};

const hu_auth_inline_toast_signed_in = /** @type {(inputs: Auth_Inline_Toast_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezett.`)
};

/**
* | output |
* | --- |
* | "Signed in." |
*
* @param {Auth_Inline_Toast_Signed_InInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_inline_toast_signed_in = /** @type {((inputs?: Auth_Inline_Toast_Signed_InInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Inline_Toast_Signed_InInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_inline_toast_signed_in(inputs)
	if (locale === "de") return de_auth_inline_toast_signed_in(inputs)
	if (locale === "zh") return zh_auth_inline_toast_signed_in(inputs)
	if (locale === "ar") return ar_auth_inline_toast_signed_in(inputs)
	if (locale === "fr") return fr_auth_inline_toast_signed_in(inputs)
	if (locale === "vi") return vi_auth_inline_toast_signed_in(inputs)
	if (locale === "sw") return sw_auth_inline_toast_signed_in(inputs)
	if (locale === "th") return th_auth_inline_toast_signed_in(inputs)
	if (locale === "bs") return bs_auth_inline_toast_signed_in(inputs)
	if (locale === "ja") return ja_auth_inline_toast_signed_in(inputs)
	if (locale === "ko") return ko_auth_inline_toast_signed_in(inputs)
	if (locale === "pt") return pt_auth_inline_toast_signed_in(inputs)
	if (locale === "it") return it_auth_inline_toast_signed_in(inputs)
	if (locale === "sv") return sv_auth_inline_toast_signed_in(inputs)
	if (locale === "nl") return nl_auth_inline_toast_signed_in(inputs)
	if (locale === "da") return da_auth_inline_toast_signed_in(inputs)
	if (locale === "nb") return nb_auth_inline_toast_signed_in(inputs)
	if (locale === "fi") return fi_auth_inline_toast_signed_in(inputs)
	if (locale === "pl") return pl_auth_inline_toast_signed_in(inputs)
	if (locale === "ru") return ru_auth_inline_toast_signed_in(inputs)
	if (locale === "tr") return tr_auth_inline_toast_signed_in(inputs)
	if (locale === "hi") return hi_auth_inline_toast_signed_in(inputs)
	if (locale === "id") return id_auth_inline_toast_signed_in(inputs)
	if (locale === "ms") return ms_auth_inline_toast_signed_in(inputs)
	if (locale === "cs") return cs_auth_inline_toast_signed_in(inputs)
	if (locale === "el") return el_auth_inline_toast_signed_in(inputs)
	if (locale === "he") return he_auth_inline_toast_signed_in(inputs)
	if (locale === "af") return af_auth_inline_toast_signed_in(inputs)
	if (locale === "hu") return hu_auth_inline_toast_signed_in(inputs)
	return en_auth_inline_toast_signed_in(inputs)
});